/* UbraTech PDP: variants, qty, gallery, accordions, spec toggle, sticky bar, add-to-cart. */
(function(){
  var d = document;
  var form = d.getElementById('product-form');
  var variants = [];
  try { variants = JSON.parse(d.querySelector('[data-product-variants]').textContent); } catch(e){}
  var qty = 1;

  function money(cents){
    var n = cents/100;
    var s = (Math.round(n*100)%100===0) ? String(Math.round(n)) : n.toFixed(2);
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return 'R' + s;
  }
  function selectedOptions(){
    return Array.prototype.map.call(d.querySelectorAll('.cfg-opts'), function(group){
      var on = group.querySelector('.cfg-opt.on');
      return on ? on.getAttribute('data-value') : null;
    });
  }
  function findVariant(){
    if(!variants.length) return null;
    if(variants.length===1) return variants[0];
    var opts = selectedOptions();
    return variants.find(function(v){
      return (v.options||[]).every(function(o,i){ return opts[i]==null || o===opts[i]; });
    }) || variants[0];
  }
  function setPrice(cents){ d.querySelectorAll('[data-price-target]').forEach(function(el){ el.textContent = money(cents); }); }
  function paint(){
    var v = findVariant();
    if(!v) return;
    var idEl = d.getElementById('variantId'); if(idEl) idEl.value = v.id;
    setPrice(v.price * qty);
    // picked labels
    d.querySelectorAll('.cfg').forEach(function(cfg, gi){
      var on = cfg.querySelector('.cfg-opt.on'); var lbl = cfg.querySelector('[data-picked]');
      if(on && lbl){ lbl.textContent = on.getAttribute('data-value'); }
    });
    var addBtn = d.getElementById('addBtn'), sbAdd = d.getElementById('sbAdd');
    var avail = v.available !== false;
    [addBtn, sbAdd].forEach(function(b){ if(b){ b.disabled = !avail; } });
  }
  d.addEventListener('click', function(e){
    var o = e.target.closest('.cfg-opt');
    if(o){ var group = o.closest('.cfg-opts');
      group.querySelectorAll('.cfg-opt').forEach(function(x){ x.classList.remove('on'); });
      o.classList.add('on'); paint(); }
  });

  var qv = d.getElementById('qVal');
  var qMinus = d.getElementById('qMinus'), qPlus = d.getElementById('qPlus');
  if(qMinus) qMinus.addEventListener('click', function(){ qty = Math.max(1, qty-1); qv.textContent = qty; paint(); });
  if(qPlus) qPlus.addEventListener('click', function(){ qty++; qv.textContent = qty; paint(); });

  /* add to cart */
  function add(){
    var v = findVariant(); if(!v || v.available===false) return;
    if(window.UBRAaddToCart){ window.UBRAaddToCart(v.id, qty); }
    else if(form){ form.submit(); }
  }
  if(form) form.addEventListener('submit', function(e){ if(window.UBRAaddToCart){ e.preventDefault(); add(); } });
  var sbAdd = d.getElementById('sbAdd'); if(sbAdd) sbAdd.addEventListener('click', add);

  /* gallery */
  var galThumbs = d.getElementById('galThumbs'), galMain = d.getElementById('galMain');
  if(galThumbs){ galThumbs.addEventListener('click', function(e){
    var b = e.target.closest('.gal-thumb'); if(!b) return;
    galThumbs.querySelectorAll('.gal-thumb').forEach(function(t){ t.classList.remove('on'); });
    b.classList.add('on');
    var full = b.getAttribute('data-full'); if(galMain && full){ galMain.src = full; }
  }); }

  /* spec toggle */
  var sTog = d.getElementById('specToggle'), sTab = d.getElementById('specTable');
  if(sTog) sTog.addEventListener('click', function(){ sTog.classList.toggle('open'); sTab.classList.toggle('open'); });

  /* faq + accordion */
  ['faq','acc'].forEach(function(id){ var r = d.getElementById(id); if(r) r.addEventListener('click', function(e){ var h = e.target.closest('.faq-q,.acc-h'); if(h) h.parentElement.classList.toggle('open'); }); });

  /* sticky bar */
  var bar = d.getElementById('stickybar'), addBtn = d.getElementById('addBtn');
  if(bar && addBtn && 'IntersectionObserver' in window){
    new IntersectionObserver(function(en){ bar.classList.toggle('on', !en[0].isIntersecting); }, {rootMargin:'0px 0px -20px 0px'}).observe(addBtn);
  }
  paint();
})();
